var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_25_663)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 33,
    fill: "url(#paint0_linear_25_663)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 65,
    rx: 32.5,
    stroke: "white",
    strokeOpacity: 0.25
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_663)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.7071 32.2931C36.8946 32.4806 36.9999 32.7349 36.9999 33.0001C36.9999 33.2652 36.8946 33.5195 36.7071 33.7071L31.0501 39.3641C30.9579 39.4596 30.8475 39.5358 30.7255 39.5882C30.6035 39.6406 30.4723 39.6682 30.3395 39.6693C30.2067 39.6705 30.075 39.6452 29.9521 39.5949C29.8292 39.5446 29.7176 39.4703 29.6237 39.3765C29.5298 39.2826 29.4556 39.1709 29.4053 39.048C29.355 38.9251 29.3297 38.7934 29.3308 38.6607C29.332 38.5279 29.3596 38.3967 29.412 38.2747C29.4644 38.1526 29.5406 38.0423 29.6361 37.9501L34.5861 33.0001L29.6361 28.0501C29.4539 27.8615 29.3531 27.6089 29.3554 27.3467C29.3577 27.0845 29.4629 26.8336 29.6483 26.6482C29.8337 26.4628 30.0845 26.3577 30.3467 26.3554C30.6089 26.3531 30.8615 26.4539 31.0501 26.6361L36.7071 32.2931Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_25_663",
    x: -5,
    y: -5,
    width: 76,
    height: 76,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_25_663"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_25_663",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25_663",
    x1: -2.75,
    y1: 68.2,
    x2: 35.9602,
    y2: -4.33594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.190425,
    stopColor: "#FF5740"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.902773,
    stopColor: "#FFE419"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_663"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(21 21)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.ca75ec7205fcd36ef1a5fbfb5220ec5d.svg";
export { ForwardRef as ReactComponent };